import { EVENTS_OPEN_ACTION_PROP_MODAL } from './constants';

export function openActionPropModal(args) {
  return {
    type: EVENTS_OPEN_ACTION_PROP_MODAL,
    data: args,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_OPEN_ACTION_PROP_MODAL:
      return {
        ...state,
        isOpenActionEnableModal: false,
        isOpenActionPropModal: true,
        selectedAction: action.data,
      };

    default:
      return state;
  }
}
